export interface CookieLifetimeOptions {
  expires?: number | Date
}

export interface CookiePolicyAttributes extends CookieLifetimeOptions {
  path: '/'
  sameSite: 'Lax'
  secure: boolean
  domain?: string
}

export interface PlatformCookieKeys {
  token: string
  accounts: string
  activeAccountId: string
}

const DEFAULT_PLATFORM_COOKIE_NAMESPACE = 'glows'
const SHARED_COOKIE_DOMAIN = 'glows.ai'

function getCurrentHostname(): string {
  return typeof location === 'undefined' ? '' : location.hostname
}

function getCurrentProtocol(): string {
  return typeof location === 'undefined' ? '' : location.protocol
}

export function buildPlatformCookieKeys(
  namespace?: string,
  hostname: string = getCurrentHostname(),
): PlatformCookieKeys {
  const configuredNamespace = namespace?.trim()
  const normalizedHostname = hostname.trim().toLowerCase().replace(/\.$/, '')
  const defaultNamespace =
    normalizedHostname === 'stage.glows.ai' || normalizedHostname.endsWith('-stage.glows.ai')
      ? 'glows_stage'
      : DEFAULT_PLATFORM_COOKIE_NAMESPACE
  const normalizedNamespace =
    configuredNamespace && /^[a-zA-Z0-9_-]+$/.test(configuredNamespace)
      ? configuredNamespace
      : defaultNamespace

  return {
    token: `${normalizedNamespace}_auth_token`,
    accounts: `${normalizedNamespace}_accounts`,
    activeAccountId: `${normalizedNamespace}_active_account_id`,
  }
}

export function getSharedCookieDomain(hostname: string = getCurrentHostname()): string | undefined {
  const normalizedHostname = hostname.trim().toLowerCase().replace(/\.$/, '')

  if (
    normalizedHostname === SHARED_COOKIE_DOMAIN ||
    normalizedHostname.endsWith(`.${SHARED_COOKIE_DOMAIN}`)
  ) {
    return SHARED_COOKIE_DOMAIN
  }

  return undefined
}

export function buildHostCookieAttributes(
  options: CookieLifetimeOptions = {},
  protocol: string = getCurrentProtocol(),
): CookiePolicyAttributes {
  return {
    ...options,
    path: '/',
    sameSite: 'Lax',
    secure: protocol === 'https:',
  }
}

export function buildSharedCookieAttributes(
  options: CookieLifetimeOptions = {},
  hostname: string = getCurrentHostname(),
  protocol: string = getCurrentProtocol(),
): CookiePolicyAttributes | undefined {
  const domain = getSharedCookieDomain(hostname)
  if (!domain) return undefined

  return {
    ...buildHostCookieAttributes(options, protocol),
    domain,
  }
}
